/**
 * mr-wheelchair-names.js -- native MuslimsReads Names component (Waqf
 * Wheelchair experience family).
 *
 * Scoped to .mr-c-wheelchair-names. Owns:
 *  1. Intent pills -> properties[Status]. 2026-07-19 founder-approved
 *     change: stored values are exactly what the customer sees. NO silent
 *     default: the hidden Status input ships disabled + empty, is enabled
 *     + filled only when a pill is actively selected, and re-disabled on
 *     deselect -- an untouched form submits no Status key at all (absent,
 *     not ""). Single-select, click-again-to-deselect.
 *     2026-07-25 (Badal): the submitted value is the pill's visible LABEL
 *     (textContent), with the legacy STATUS_MAP as fallback -- per-product
 *     pill sets (snippet reads mr_core.status_pills) submit exactly what
 *     they display. Default trio submits byte-identical values.
 *  2. Situation textarea (2026-07-25, Badal) -> properties[Beneficiary
 *     Situation]. Rendered by the snippet only when mr_core.situation_field
 *     is set; this JS shows + enables it ONLY while the pill whose intent
 *     matches data-wn-situation-intent is selected, and hides + disables it
 *     otherwise (disabled input = key absent from the order). Captures why
 *     the beneficiary cannot travel, for scholar review.
 *  3. Gender pills -> properties[Gender] ("Man"/"Woman"). NO default
 *     selection; untouched form submits no Gender key.
 *  4. The automatic, intent-aware acknowledgement, revealed live off the
 *     name input's own 'input' event.
 *
 * Act noun comes from the container's data-mr-act-word (fallback "gift").
 * NO-PILLS MODE (show_gender_status unchecked): name + acknowledgement
 * still work; acknowledgement uses the neutral 'deceased' phrasing.
 * properties[Proof Requested] was REMOVED ENTIRELY (2026-07-19).
 * All fields are optional -- nothing here blocks Add to cart.
 */
(function () {
  'use strict';

  // Legacy fallback map only -- the submitted value is the pill's visible
  // label (textContent) first.
  var STATUS_MAP = { living: 'Living', shifa: 'Seeking shifa', deceased: 'Deceased' };
  var DEFAULT_INTENT = 'living'; // acknowledgement copy fallback ONLY -- never submitted
  var ACTIVE_CLASS = 'mr-c-wheelchair-names__pill--on';
  var ACK_VISIBLE_CLASS = 'is-visible';

  var DEFAULT_ACT_WORD = 'gift';
  function ackPrefixFor(actWord) {
    return {
      living: 'This ' + actWord + ' will be fulfilled in honour of',
      deceased: 'This ' + actWord + ' will be completed on behalf of',
      shifa: 'This ' + actWord + ' will be fulfilled for'
    };
  }

  function wire(root) {
    var pillsWrap = root.querySelector('[data-mr-wn-pills]');
    var statusInput = root.querySelector('[data-mr-wn-status]');
    var nameInput = root.querySelector('[data-mr-wn-name]');
    var ackWrap = root.querySelector('[data-mr-wn-ack]');
    var ackPrefixEl = root.querySelector('[data-mr-wn-ack-prefix]');
    var ackNameEl = root.querySelector('[data-mr-wn-ack-name]');
    var situationWrap = root.querySelector('[data-mr-wn-situation]');
    var situationInput = root.querySelector('[data-mr-wn-situation-input]');
    var situationIntent = situationWrap ? situationWrap.getAttribute('data-wn-situation-intent') : null;
    var hasStatusUI = !!(pillsWrap && statusInput);
    if (!hasStatusUI && !nameInput) return;
    var actWord = (root.getAttribute('data-mr-act-word') || '').trim() || DEFAULT_ACT_WORD;
    var ACK_PREFIX = ackPrefixFor(actWord);
    var currentIntent = hasStatusUI ? DEFAULT_INTENT : 'deceased';

    function syncAck() {
      if (!ackWrap || !nameInput) return;
      var trimmed = (nameInput.value || '').trim();
      if (ackPrefixEl) ackPrefixEl.textContent = ACK_PREFIX[currentIntent] || ACK_PREFIX[DEFAULT_INTENT];
      if (ackNameEl) ackNameEl.textContent = trimmed;
      if (trimmed.length > 0) {
        ackWrap.classList.add(ACK_VISIBLE_CLASS);
      } else {
        ackWrap.classList.remove(ACK_VISIBLE_CLASS);
      }
    }

    // Situation textarea: visible + enabled ONLY while the matching intent
    // pill is actively selected. Hidden + disabled otherwise, so the
    // property never submits unless the customer chose that status.
    function syncSituation(activeIntent) {
      if (!situationWrap || !situationInput) return;
      if (activeIntent !== null && activeIntent === situationIntent) {
        situationWrap.hidden = false;
        situationInput.disabled = false;
      } else {
        situationWrap.hidden = true;
        situationInput.disabled = true;
      }
    }

    if (hasStatusUI) {
      var pills = Array.prototype.slice.call(pillsWrap.querySelectorAll('[data-wn-intent]'));
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var wasActive = pill.classList.contains(ACTIVE_CLASS);

          pills.forEach(function (p) {
            p.classList.remove(ACTIVE_CLASS);
            p.setAttribute('aria-pressed', 'false');
          });

          if (wasActive) {
            statusInput.value = '';
            statusInput.disabled = true;
            currentIntent = DEFAULT_INTENT;
            syncSituation(null);
          } else {
            pill.classList.add(ACTIVE_CLASS);
            pill.setAttribute('aria-pressed', 'true');
            var intent = pill.getAttribute('data-wn-intent');
            statusInput.disabled = false;
            statusInput.value = (pill.textContent || '').trim() || STATUS_MAP[intent] || '';
            currentIntent = intent;
            syncSituation(intent);
          }

          syncAck();
        });
      });
      syncSituation(null);
    }

    var genderWrap = root.querySelector('[data-mr-wn-gender-pills]');
    var genderInput = root.querySelector('[data-mr-wn-gender]');
    if (genderWrap && genderInput) {
      var genderPills = Array.prototype.slice.call(genderWrap.querySelectorAll('[data-wn-gender]'));
      genderPills.forEach(function (gp) {
        gp.addEventListener('click', function () {
          genderPills.forEach(function (p) {
            p.classList.remove(ACTIVE_CLASS);
            p.setAttribute('aria-pressed', 'false');
          });
          gp.classList.add(ACTIVE_CLASS);
          gp.setAttribute('aria-pressed', 'true');
          genderInput.disabled = false;
          genderInput.value = gp.getAttribute('data-wn-gender');
        });
      });
    }

    if (nameInput) {
      nameInput.addEventListener('input', syncAck);
      syncAck();
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.mr-c-wheelchair-names').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.MRWheelchairNames = { init: init };
})();
